$(document).ready(function(){
  $('.multicolumn-slider').slick({
    slidesToShow: 3,
    dots:true,
    autoplay:true,
    autoplaySpeed:5000,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1
        }
      }
     ]
  });
  
});

